export default "__VITE_ASSET__DMaGEyug__"